module.exports = __webpack_public_path__ + "static/img/slider-1.4b4e7f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/static-css/img/slider/slider-1.jpg
// module id = AiB/
// module chunks = 19